import Mock from 'mockjs'

// var menulist = []
// function getList() {
// axios.get('http://192.168.2.25:5555/website/solution/get').then(res => {
//     // console.log(res.data.data)
//     menulist = res.data.data
// })
// }
// window.onload = function () {
//     getList()
//     console.log(menulist)
// }


// console.log(menuData)
// console.log(solveList)
// var solveList = getList()
// console.log(solveList)



let list = {
    total: 0,
    menu: [
        {
            name: '首页',
            url: '/home/index',
            subShow: false,
            select: true,
        },
        {
            name: '解决方案',
            subShow: false,
            select: false,
            url: '/cmpMainbusiness/finance',
            subList: [
                {
                    name: 'RPA+AI数字员工',
                    select: false,
                    url: '/cmpMainbusiness/finance',
                    type: 3
                },
                {
                    name: '科研力量',
                    select: false,
                    url: '/cmpMainbusiness/scientific',
                    type: 3
                }
            ]
        },
        {
            name: '产品服务',
            subShow: false,
            select: false,
            url: '/cusCase/caselist',
            subList: [
                {
                    name: '案例展示',
                    select: false,
                    url: '/cusCase/caselist',
                    type: 2
                },
                {
                    name: '合作客户',
                    select: false,
                    url: '/cusCase/coopCus',
                    type: 2
                }
            ]
        },
        {
            name: '客户案例',
            subShow: false,
            select: false,
            url: '/gotosigao/befintroduction',
            subList: [

                {
                    name: '公司简介',
                    select: false,
                    url: '/gotosigao/befintroduction',
                    type: 0
                },
                {
                    name: '公司团队',
                    select: false,
                    url: '/gotosigao/team',
                    type: 0
                },
                {
                    name: '企业文化',
                    select: false,
                    url: '/gotosigao/culture',
                    type: 0
                },
            ],
        },
        {
            name: '新闻资讯',
            subShow: false,
            select: false,
            url: '/news/index',
        },
        {
            name: '关于芸希',
            subShow: false,
            select: false,
            url: '/joinus/advertise',
            subList: [
                {
                    name: '人才招聘',
                    select: false,
                    url: '/joinus/advertise',
                    type: 1
                },
                {
                    name: '联系我们',
                    select: false,
                    url: '/joinus/connet',
                    type: 1
                },
            ],
        }
    ],
    bannerList: [
        require('./../assets/images/banner01.png'),
        'https://nwzimg.wezhan.cn/contents/sitefiles2045/10228120/images/20939021.jpg',
        require('./../assets/images/banner02.gif')
    ],
    data: [],
}
//获取菜单
Mock.mock('/getMenu', 'get', req => {

    return {
        code: 200,
        msg: '操作成功',
        data: list.menu,
    }
})
//获取首页轮播图
Mock.mock('/getBanner', 'get', req => {

    return {
        code: 200,
        msg: '操作成功',
        data: list.bannerList,
    }
})
export default {
    list,
}
